import Report from './ReportDetailController';

export default Report;
